import posthog from "posthog-js";

// Check if PostHog is blocked
const isPostHogBlocked = () => {
  try {
    return (
      window.navigator.doNotTrack === "1" ||
      !window.navigator.onLine ||
      window.localStorage.getItem("posthog_disabled") === "true"
    );
  } catch {
    return true;
  }
};

// PostHog utility functions with safety checks
export const initPostHog = () => {
  if (!isPostHogBlocked()) {
    try {
      const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
      if (!posthogKey) {
        console.warn("PostHog API key not configured");
        return false;
      }
      posthog.init(posthogKey, {
        api_host: "https://us.i.posthog.com",
        loaded: (posthog) => {
          // Debug mode disabled to prevent console logging
        },
        autocapture: false, // Disable autocapture to reduce requests
        capture_pageview: false, // We'll handle this manually
        enable_recording: false, // Disable session recording for privacy
        persistence: "localStorage", // Use localStorage instead of cookies
        bootstrap: {
          distinctID: "anonymous", // Default anonymous tracking
          isIdentifiedID: false,
        },
      });
      return true;
    } catch (error) {
      // console.warn("PostHog initialization failed:", error);
      return false;
    }
  }
  return false;
};

export const trackPageView = () => {
  if (!isPostHogBlocked()) {
    try {
      posthog.capture("$pageview");
    } catch (error) {
      // console.warn("PostHog pageview tracking failed:", error);
    }
  }
};

export const trackEvent = (eventName, properties = {}) => {
  if (!isPostHogBlocked()) {
    try {
      posthog.capture(eventName, properties);
    } catch (error) {
      // console.warn("PostHog event tracking failed:", error);
    }
  }
};

export const identifyUser = (userId, properties = {}) => {
  if (!isPostHogBlocked()) {
    try {
      posthog.identify(userId, properties);
    } catch (error) {
      // console.warn("PostHog user identification failed:", error);
    }
  }
};

export const resetUser = () => {
  if (!isPostHogBlocked()) {
    try {
      posthog.reset();
    } catch (error) {
      // console.warn("PostHog user reset failed:", error);
    }
  }
};

export default posthog;
